// Mapowanie ikon zgodne z data/icon-map.json (biblioteka: Lucide).
import {
  UserRound, Menu, X, ArrowRight, Copy, Search, CircleCheck,
  Clock3, CircleX, WalletCards, Sparkles, PackageSearch, Gem, House,
  HardHat, BadgeCheck, PawPrint, ChefHat, MousePointer2, WandSparkles,
  ChevronDown, Heart, RefreshCw, BadgePlus,
} from "lucide-react";

export const ICONS = {
  account: UserRound,
  menu: Menu,
  close: X,
  arrowRight: ArrowRight,
  copy: Copy,
  search: Search,
  check: CircleCheck,
  timeProblem: Clock3,
  inconsistentProblem: CircleX,
  costProblem: WalletCards,
  aiInfluencers: Sparkles,
  productsEcommerce: PackageSearch,
  beautyFashionSalons: Gem,
  realEstateInteriors: House,
  constructionLocalServices: HardHat,
  personalBrandExperts: BadgeCheck,
  pets: PawPrint,
  gastronomy: ChefHat,
  select: MousePointer2,
  create: WandSparkles,
  faqChevron: ChevronDown,
  favorite: Heart,
  updates: RefreshCw,
  full: BadgePlus,
};

// Powiązanie ID pakietu (homepage-copy.json) z kluczem ikony.
export const PACKAGE_ICON = {
  "ai-influencers": "aiInfluencers",
  "products-ecommerce": "productsEcommerce",
  "beauty-fashion-salons": "beautyFashionSalons",
  "real-estate-interiors": "realEstateInteriors",
  "construction-local-services": "constructionLocalServices",
  "personal-brand-experts": "personalBrandExperts",
  pets: "pets",
  gastronomy: "gastronomy",
};

// Problem section icons in order
export const PROBLEM_ICONS = ["timeProblem", "inconsistentProblem", "costProblem"];
// How it works step icons in order
export const STEP_ICONS = ["select", "copy", "create"];

export const STROKE = 1.75;
